export default __webpack_public_path__ + "static/media/check-out-v2.aa3680c3.svg";